/* eslint-disable */
import {CheckoutDeliveryItem} from './CheckoutDeliveryItem';
import {ProductUnfulfilled} from './ProductUnfulfilled';
import {CheckoutFormData} from './CheckoutFormData';
import {Summary} from './Summary';
import {PaymentMethod} from './PaymentMethod';
import {FulfilmentResponse} from './FulfilmentResponse';
import {PurchaseResponse} from './PurchaseResponse';
import {ICart} from './ICart';
import {AdminUserInfo} from 'authorization/models/AdminUserInfo';
import {AddressInfo} from './AddressInfo';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.src.views.CheckoutPage.CheckoutPageModel
*/
export interface CheckoutPageModel extends BasePageModel {
	isSingleProduct: boolean;
	deliveries: CheckoutDeliveryItem[];
	unfulfilledProducts: ProductUnfulfilled[];
	showDeliveries: boolean;
	isQuickStart: boolean;
	initialValues: CheckoutFormData;
	summary: Summary;
	paymentMethods: PaymentMethod[];
	fulfilment: FulfilmentResponse;
	purchaseResponse?: PurchaseResponse;
	cart?: ICart;
	disableCardPaymentROTFeatureToggle: boolean;
	removeCheckoutMessageBoxFeatureToggle: boolean;
	userInfo: AdminUserInfo;
	isBankIdActive: boolean;
	addressInfo: AddressInfo;
}
export const isCheckoutPage = (model: unknown): model is CheckoutPageModel => (model as CheckoutPageModel).componentName === 'CheckoutPage';
